import { StyleSheet } from 'aphrodite/no-important';
import { IGenericObject } from 'models/base';
import { palette } from 'util/style-helpers';

export const style: any = (styles: IGenericObject) => {
  return StyleSheet.create({
    channelImage: {
      padding: '10px 0px',
    },
    channelImageContainer: {
      height: '100%',
      position: 'relative',
    },
    channelUserPresence: {
      position: 'absolute',
      right: -7,
      bottom: 4,
      height: 15,
      width: 15,
      border: `2px solid ${palette.lightGrey}`,
      zIndex: 10,
      borderRadius: 10,
      backgroundColor: palette.lighterGrey,
    },
    online: {
      backgroundColor: palette.green,
    },
    offline: {
      backgroundColor: palette.grey,
    },
  });
};
